import { render, staticRenderFns } from "./EmpresasParceiras.vue?vue&type=template&id=b6719590"
import script from "./EmpresasParceiras.vue?vue&type=script&lang=js"
export * from "./EmpresasParceiras.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports